import { render, staticRenderFns } from "./DocumentPrinter.vue?vue&type=template&id=5a0a3bf5&scoped=true&"
import script from "./DocumentPrinter.vue?vue&type=script&lang=ts&"
export * from "./DocumentPrinter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a3bf5",
  null
  
)

export default component.exports